import { deviceDetected } from 'planoplan-ui-kit/core/device-detected';
import { OS } from '@constants';
import { OS_OPTIONS } from '@constants/params';

export const getOsData = (locale = 'en') => {
  const os = deviceDetected.isMac ? OS.MAC : OS.WINDOWS;
  const osSecond = deviceDetected.isMac ? OS.WINDOWS : OS.MAC;
  const title = OS_OPTIONS[os].title;
  const downloadLink = OS_OPTIONS[os].getDownloadLink(locale);
  const downloadLinkSecond = OS_OPTIONS[os === OS.MAC ? OS.WINDOWS : OS.MAC].getDownloadLink(locale);

  return { os, osSecond, title, downloadLink, downloadLinkSecond };
};
